export default "__VITE_ASSET__43bc1d95__"